/**
 * Order Status Type Definitions
 *
 * Defines valid order statuses and their metadata for the admin interface
 */

export type OrderStatus =
  | 'created'
  | 'vetting'
  | 'rejected'
  | 'awaiting_submission'
  | 'submitted'
  | 'production'
  | 'shipped'
  | 'delivered';

export interface OrderStatusMetadata {
  value: OrderStatus;
  label: string;
  description: string;
}

export const ORDER_STATUSES: OrderStatusMetadata[] = [
  {
    value: 'created',
    label: 'Created',
    description: 'An order has been sent by the user to Supabase and is awaiting vetting.'
  },
  {
    value: 'vetting',
    label: 'Vetting',
    description: 'Waiting to be vetted before being sent to printer.'
  },
  {
    value: 'rejected',
    label: 'Rejected',
    description: 'Failed vetting and user will be contacted.'
  },
  {
    value: 'awaiting_submission',
    label: 'Awaiting Submission',
    description: 'Passed vetting and awaiting submission to printer.'
  },
  {
    value: 'submitted',
    label: 'Submitted',
    description: 'Submitted to printer.'
  },
  {
    value: 'production',
    label: 'Production',
    description: 'Is being printed and processed by the printer.'
  },
  {
    value: 'shipped',
    label: 'Shipped',
    description: 'Shipped to user by printer.'
  },
  {
    value: 'delivered',
    label: 'Delivered',
    description: 'User received order (may not be possible to tell this?).'
  }
];

/**
 * Get status metadata by value
 */
export function getStatusMetadata(status: OrderStatus): OrderStatusMetadata | undefined {
  return ORDER_STATUSES.find(s => s.value === status);
}

/**
 * Check if a string is a valid order status
 */
export function isValidOrderStatus(status: string): status is OrderStatus {
  return ORDER_STATUSES.some(s => s.value === status);
}
